import {
  UserRegistrationActions,
  UserRegistrationActionTypes
} from '@appStore/account/actions/user-registration.actions';
import { ManagerCompany } from '@model';

export interface State {
  saving: boolean;
  saved: boolean;
  saveFailed: boolean;
  loading: boolean;
  loaded: boolean;
  customerValid: boolean;
  customerValidLoading: boolean;
  customerValidLoaded: boolean;
  registeredOnSegment: boolean;
  registeredOnSegmentLoading: boolean;
  registeredOnSegmentLoaded: boolean;
  additionalSaving: boolean;
  additionalSaved: boolean;
  additionalSaveFailed: boolean;
  registeredOnCompany: boolean;
  registeredOnCompanyLoading: boolean;
  registeredOnCompanyLoaded: boolean;
  managerCompany: ManagerCompany;
  managerCompanyCreating: boolean;
  managerCompanyCreated: boolean;
  managerCompanyCreatedFail: boolean;
  additionalManagerCompanyCreating: boolean;
  additionalManagerCompanyCreated: boolean;
  additionalManagerCompanyCreatedFail: boolean;
  customerUserType: number;
  customerUserTypeLoading: boolean;
  customerUserTypeLoaded: boolean;
  managerCompanyOrgNumberExistingCustomer: boolean;
  managerCompanyOrgNumberExistingCustomerLoading: boolean;
  managerCompanyOrgNumberExistingCustomerLoaded: boolean;
  customerMeteringPointsValid: boolean;
  customerMeteringPointsValidLoaded: boolean;
  customerMeteringPointsValidLoading: boolean;
}

export const initialState: State = {
  saving: false,
  saved: false,
  saveFailed: false,
  loading: false,
  loaded: false,
  customerValid: false,
  customerValidLoading: false,
  customerValidLoaded: false,
  registeredOnSegment: false,
  registeredOnSegmentLoading: false,
  registeredOnSegmentLoaded: false,
  additionalSaving: false,
  additionalSaved: false,
  additionalSaveFailed: false,
  registeredOnCompany: false,
  registeredOnCompanyLoading: false,
  registeredOnCompanyLoaded: false,
  managerCompany: null,
  managerCompanyCreating: false,
  managerCompanyCreated: false,
  managerCompanyCreatedFail: false,
  additionalManagerCompanyCreating: false,
  additionalManagerCompanyCreated: false,
  additionalManagerCompanyCreatedFail: false,
  customerUserType: null,
  customerUserTypeLoading: false,
  customerUserTypeLoaded: false,
  managerCompanyOrgNumberExistingCustomer: false,
  managerCompanyOrgNumberExistingCustomerLoading: false,
  managerCompanyOrgNumberExistingCustomerLoaded: false,
  customerMeteringPointsValid: false,
  customerMeteringPointsValidLoaded: false,
  customerMeteringPointsValidLoading: false
};

export function reducer(state = initialState, action: UserRegistrationActions): State {
  switch (action.type) {
    case UserRegistrationActionTypes.UserRegistrationUpdateItem:
      return { ...state, saving: true, saved: false, saveFailed: false };
    case UserRegistrationActionTypes.UserRegistrationUpdateItemFail:
      return { ...state, saving: false, saved: false, saveFailed: true };
    case UserRegistrationActionTypes.UserRegistrationUpdateItemSuccess:
      return { ...state, saving: false, saved: true, saveFailed: false };
    case UserRegistrationActionTypes.AutoUserRegistration:
        return { ...state, saving: true, saved: false, saveFailed: false };
    case UserRegistrationActionTypes.AutoUserRegistrationFail:
        return { ...state, saving: false, saved: false, saveFailed: true };
    case UserRegistrationActionTypes.AutoUserRegistrationSuccess:
        return { ...state, saving: false, saved: true, saveFailed: false };
    case UserRegistrationActionTypes.IsCustomerUserTypeValid:
      return { ...state, customerValidLoaded: false, customerValidLoading: true, customerValid: false };
    case UserRegistrationActionTypes.IsCustomerUserTypeValidFail:
      return { ...state, customerValidLoaded: false, customerValidLoading: false };
    case UserRegistrationActionTypes.IsCustomerUserTypeValidSuccess:
      return { ...state, customerValidLoaded: true, customerValidLoading: false, customerValid: action.payload };
    case UserRegistrationActionTypes.IsRegisteredOnSegment:
      return {
        ...state,
        registeredOnSegmentLoaded: false,
        registeredOnSegmentLoading: true,
        registeredOnSegment: false
      };
    case UserRegistrationActionTypes.IsRegisteredOnSegmentFail:
      return { ...state, registeredOnSegmentLoaded: false, registeredOnSegmentLoading: false };
    case UserRegistrationActionTypes.IsRegisteredOnSegmentSuccess:
      return {
        ...state,
        registeredOnSegmentLoaded: true,
        registeredOnSegmentLoading: false,
        registeredOnSegment: action.payload
      };
    case UserRegistrationActionTypes.AdditionalCustomerRegistration:
      return { ...state, additionalSaving: true, additionalSaved: false, additionalSaveFailed: false };
    case UserRegistrationActionTypes.AdditionalCustomerRegistrationFail:
      return { ...state, additionalSaving: false, additionalSaved: false, additionalSaveFailed: true };
    case UserRegistrationActionTypes.AdditionalCustomerRegistrationSuccess:
      return { ...state, additionalSaving: false, additionalSaved: true, additionalSaveFailed: false };
    case UserRegistrationActionTypes.IsRegisteredOnCompany:
      return {
        ...state,
        registeredOnCompanyLoaded: false,
        registeredOnCompanyLoading: true,
        registeredOnCompany: false
      };
    case UserRegistrationActionTypes.IsRegisteredOnCompanyFail:
      return { ...state, registeredOnCompanyLoaded: false, registeredOnCompanyLoading: false };
    case UserRegistrationActionTypes.IsRegisteredOnCompanySuccess:
      return {
        ...state,
        registeredOnCompanyLoaded: true,
        registeredOnCompanyLoading: false,
        registeredOnCompany: action.payload
      };
    case UserRegistrationActionTypes.CreateManagerCompany:
      return { ...state, managerCompanyCreating: true, managerCompanyCreated: false, managerCompanyCreatedFail: false };
    case UserRegistrationActionTypes.CreateManagerCompanyFail:
      return { ...state, managerCompanyCreating: false, managerCompanyCreated: false, managerCompanyCreatedFail: true };
    case UserRegistrationActionTypes.CreateManagerCompanySuccess:
      return {
        ...state,
        managerCompanyCreating: false,
        managerCompanyCreated: true,
        managerCompany: action.payload,
        managerCompanyCreatedFail: false
      };

    case UserRegistrationActionTypes.CreateAdditionalManagerCompany:
      return {
        ...state,
        additionalManagerCompanyCreating: true,
        additionalManagerCompanyCreated: false,
        additionalManagerCompanyCreatedFail: false
      };
    case UserRegistrationActionTypes.CreateAdditionalManagerCompanyFail:
      return {
        ...state,
        additionalManagerCompanyCreating: false,
        additionalManagerCompanyCreated: false,
        additionalManagerCompanyCreatedFail: true
      };
    case UserRegistrationActionTypes.CreateAdditionalManagerCompanySuccess:
      return {
        ...state,
        additionalManagerCompanyCreating: false,
        additionalManagerCompanyCreated: true,
        managerCompany: action.payload,
        additionalManagerCompanyCreatedFail: false
      };

    case UserRegistrationActionTypes.ClearCreateManagerCompanyState:
      return {
        ...state,
        managerCompanyCreating: false,
        managerCompanyCreated: false,
        additionalManagerCompanyCreating: false,
        additionalManagerCompanyCreated: false,
        registeredOnCompanyLoaded: false,
        managerCompanyCreatedFail: false,
        additionalManagerCompanyCreatedFail: false
      };

    case UserRegistrationActionTypes.ClearUpdateUserRegistrationState:
      return {
        ...state,
        saved: false,
        saving: false,
        saveFailed: false,
        customerValidLoaded: false
      };

    case UserRegistrationActionTypes.ClearCreateAdditionalCustomerState:
      return {
        ...state,
        additionalSaving: false,
        additionalSaved: false,
        additionalSaveFailed: false
      };

    case UserRegistrationActionTypes.CustomerUserTypeLoadData:
      return {
        ...state,
        customerUserType: null,
        customerUserTypeLoading: true,
        customerUserTypeLoaded: false
      };
    case UserRegistrationActionTypes.CustomerUserTypeLoadDataFail:
      return { ...state, customerUserTypeLoaded: false, customerUserTypeLoading: false };
    case UserRegistrationActionTypes.CustomerUserTypeLoadDataSuccess:
      return {
        ...state,
        customerUserType: action.payload,
        customerUserTypeLoading: false,
        customerUserTypeLoaded: true
      };
    case UserRegistrationActionTypes.ClearCustomerUserTypeState:
      return {
        ...state,
        customerUserType: null,
        customerUserTypeLoading: false,
        customerUserTypeLoaded: false
      };
    case UserRegistrationActionTypes.ClearManagerCustomerValidState:
      return {
        ...state,
        registeredOnSegmentLoaded: false,
        registeredOnSegmentLoading: false,
        registeredOnSegment: false,
        customerValidLoaded: false,
        customerValidLoading: false,
        customerValid: false
      };
    case UserRegistrationActionTypes.IsManagerCompanyOrgNumberExistingCustomer:
        return { ...state, managerCompanyOrgNumberExistingCustomerLoaded: false,
          managerCompanyOrgNumberExistingCustomerLoading: true,
          managerCompanyOrgNumberExistingCustomer: false };
    case UserRegistrationActionTypes.IsManagerCompanyOrgNumberExistingCustomerFail:
        return { ...state, managerCompanyOrgNumberExistingCustomerLoaded: false,
          managerCompanyOrgNumberExistingCustomerLoading: false };
    case UserRegistrationActionTypes.IsManagerCompanyOrgNumberExistingCustomerSuccess:
        return { ...state, managerCompanyOrgNumberExistingCustomerLoaded: true,
          managerCompanyOrgNumberExistingCustomerLoading: false,
          managerCompanyOrgNumberExistingCustomer: action.payload };

      case UserRegistrationActionTypes.IsCustomerMeteringPointsValid:
          return { 
            ...state, 
            customerMeteringPointsValidLoaded: false, 
            customerMeteringPointsValidLoading: true, 
            customerMeteringPointsValid: false };
      case UserRegistrationActionTypes.IsCustomerMeteringPointsValidFail:
          return { 
            ...state, 
            customerMeteringPointsValidLoaded: false, 
            customerMeteringPointsValidLoading: false, 
            customerMeteringPointsValid: false };
      case UserRegistrationActionTypes.IsCustomerMeteringPointsValidSuccess:
          return { 
            ...state, 
            customerMeteringPointsValidLoaded: true, 
            customerMeteringPointsValidLoading: false, 
            customerMeteringPointsValid: action.payload };
  }
  return state;
}

export const getUserRegistrationSaved = (state: State) => state.saved;
export const getUserRegistrationSaving = (state: State) => state.saving;
export const getUserRegistrationSaveFailed = (state: State) => state.saveFailed;
export const getAutoUserRegistrationSaved = (state: State) => state.saved;
export const getAutoUserRegistrationSaving = (state: State) => state.saving;
export const getAutoUserRegistrationSaveFailed = (state: State) => state.saveFailed;
export const getIsCustomerValid = (state: State) => state.customerValid;
export const getIsCustomerValidLoaded = (state: State) => state.customerValidLoaded;
export const getIsRegisteredOnSegment = (state: State) => state.registeredOnSegment;
export const getIsRegisteredOnSegmentLoaded = (state: State) => state.registeredOnSegmentLoaded;
export const getAdditionalCustomerRegistrationSaved = (state: State) => state.additionalSaved;
export const getAdditionalCustomerRegistrationSaveFailed = (state: State) => state.additionalSaveFailed;
export const getIsRegisteredOnCompany = (state: State) => state.registeredOnCompany;
export const getIsRegisteredOnCompanyLoaded = (state: State) => state.registeredOnCompanyLoaded;
export const getManagerCompany = (state: State) => state.managerCompany;
export const getManagerCompanyCreated = (state: State) => state.managerCompanyCreated;
export const getAdditionalManagerCompanyCreated = (state: State) => state.additionalManagerCompanyCreated;
export const getCustomerUserType = (state: State) => state.customerUserType;
export const getCustomerUserTypeLoaded = (state: State) => state.customerUserTypeLoaded;
export const getManagerCompanyCreatedFail = (state: State) => state.managerCompanyCreatedFail;
export const getAdditionalManagerCompanyCreatedFail = (state: State) => state.additionalManagerCompanyCreatedFail;
export const getIsManagerCompanyOrgNumberExistingCustomer = (state: State) => state.managerCompanyOrgNumberExistingCustomer;
export const getIsManagerCompanyOrgNumberExistingCustomerLoaded = (state: State) => state.managerCompanyOrgNumberExistingCustomerLoaded;
export const getIsCustomerMeteringPointsValid = (state: State) => state.customerMeteringPointsValid;
export const getIsCustomerMeteringPointsValidLoaded = (state: State) => state.customerMeteringPointsValidLoaded;
